var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongformP = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 10,
  viewBox: "0 0 8 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 9.947h4.57V9.21l-1.618-.234V6.15c.266-.006.634-.013 1.193-.006 2.025.019 3.758-1.137 3.758-3.238C7.903.59 6.303 0 4.303 0c-.875 0-1.675.089-2.215.089H.076v.92l1.073.172v7.788L0 9.21zm2.952-4.761V.99c.235-.07.685-.095.984-.101 1.307-.007 2.158.609 2.158 1.967 0 1.898-.952 2.4-1.987 2.4a8 8 0 0 1-1.155-.07"
})));
export default SvgLongformP;